'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Textfit = undefined;

var _Textfit = require('./Textfit');

var _Textfit2 = _interopRequireDefault(_Textfit);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.Textfit = _Textfit2.default;
exports.default = _Textfit2.default;